<template>
  <!-- 罪名快速查找刑事辩护律师 -->
  <div class="zmkssealaw">
    <sub-title text="快速查找刑事辩护律师" />
    <div class="selebtn flex mt30">
      <el-select
        :popper-append-to-body="false"
        v-model="value"
        placeholder="请选择"
        class="sele1"
      >
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <div class="fgline"></div>
      <el-select
        v-model="value"
        :popper-append-to-body="false"
        placeholder="请选择"
        class="sele1"
      >
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
    </div>
    <div class="seabtn">搜索</div>
  </div>
</template>

<script>
import subTitle from "views/home/components/subTitle";
export default {
  components: {
    subTitle,
  },
  data() {
    return {
      options: [
        {
          value: "选项1",
          label: "黄金糕",
        },
        {
          value: "选项2",
          label: "双皮奶",
        },
        {
          value: "选项3",
          label: "蚵仔煎",
        },
        {
          value: "选项4",
          label: "龙须面",
        },
        {
          value: "选项5",
          label: "北京烤鸭",
        },
      ],
      value: "",
    };
  },
};
</script>

<style lang="scss" scoped>
.zmkssealaw {
  padding: 22px 12px;
  .selebtn {
    .fgline {
      width: 10px;
      height: 2px;
      background: #d7d7d7;
      position: relative;
      top: 20px;
      margin: 0 4px;
    }
    .sele1 {
      flex: 1;
      height: 40px;
    }
  }
  .seabtn {
    cursor: pointer;
    margin-top: 20px;
    width: 290px;
    height: 36px;
    line-height: 36px;
    text-align: center;
    background: #0465ea;
    border-radius: 2px;
    font-size: 16px;
    color: #ffffff;
  }
}
</style>